var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mx-2 leading-5 bg-gray-400 rounded-full"},[_c('button',{staticClass:"flex inline-flex items-center justify-center w-full px-6 py-2 text-base font-medium leading-5 rounded-full focus:bg-blue-600 focus:outline-none focus:text-white",class:{
            'bg-gray-400  text-gray-700': !_vm.isChecked,
            'bg-blue-600 text-white': _vm.isChecked
        },on:{"click":_vm.updateValue}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }